import { log } from '@/log'
import { ApiClient, ApiClientWithAuth } from '@/services/api/client'
import { Either, left, right } from 'fp-ts/lib/Either'

export class AssociationService {
  constructor(
    private readonly apiClient: typeof ApiClient = ApiClientWithAuth
  ) {}

  async list(brandEnglishName: string, query: ListQuery = {}): Promise<Either<Error, AssociationItem[]>> {
    const target = `/api/user/external_account_association/${brandEnglishName}/association_list`

    try {
      const response = await this.apiClient.get(target, query)

      log.debug({ service: target, response })

      return right(response.body.data)
    } catch (error) {
      log.error({ service: target, error })

      return left(error)
    }
  }
}

export interface AssociationItem {
  brand_id: string
  external_service_kind: string
}

export interface ListQuery {
  serviceId?: string
}
